import { CommonModule, ViewportScroller } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { FilterService, MessageService, SelectItem } from 'primeng/api';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { Subject, catchError, map, of, takeUntil } from 'rxjs';
import { EnumTypeNotification } from 'src/app/enumeration/EnumTypeNotification';
import { DataStateEnum } from 'src/app/enumeration/dataState.enum';
import { Bien } from 'src/app/models/Bien';
import { ContactDto } from 'src/app/models/ContactDto';
import { LotBynumOpe } from 'src/app/models/LotBynumOpe';
import { lotDetails } from 'src/app/models/LotDetails';
import { Ope } from 'src/app/models/Ope';
import { OptionCreateDto } from 'src/app/models/OptionCreateDto';
import { OptionFreeDto } from 'src/app/models/OptionFreeDto';
import { OptionReconductionDto } from 'src/app/models/OptionReconductionDto';
import { SearchOpeCriteria } from 'src/app/models/SearchOpeCriteria';
import { SimpleContactForm } from 'src/app/models/SimpleContactForm';
import { Value } from 'src/app/models/Value';
import { contactsDto } from 'src/app/models/contactsDto';
import { createContacts } from 'src/app/models/createContact';
import { lotSecondaireDto } from 'src/app/models/lotSecondaireDto';
import { renewOption } from 'src/app/models/renwewOption';
import { Statuses } from 'src/app/models/statuses';
import { vignetteOpe } from 'src/app/models/vignetteOpe';
import { ScrollService } from 'src/app/services/Utils/scroll.service';
import { BienService } from 'src/app/services/bi/bi.service';
import { ContactsService } from 'src/app/services/contacts/contacts.services';
import { DocServices } from 'src/app/services/docs/docs.services';
import { OpeService } from 'src/app/services/ope/ope.service';
import { OptionServices } from 'src/app/services/options/option.service';
import { PersistanceService } from 'src/app/services/persistenceStorage/localstorage.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { SidebarService } from 'src/app/services/sideBare.service';
import { Lot } from 'src/domain/lotdetail';
import { userProfilDto } from 'src/app/models/userProfilDto';
import { KeycloakService } from 'keycloak-angular';
import { collabService } from 'src/app/services/collab/collabService.service';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SelectModule } from 'primeng/select';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';


interface Civil {
  type: string;
  code: string;
}

@Component({
  selector: 'app-liste-biens',
  templateUrl: './liste-biens.component.html',
  imports: [CommonModule,ToastModule,ProgressBarModule,TableModule,MatProgressSpinnerModule,SelectModule,TagModule,TooltipModule,DialogModule,ButtonModule,AutoCompleteModule,ReactiveFormsModule,FormsModule],
  styleUrls: ['./liste-biens.component.scss'],
  providers: [MessageService, OptionServices]

})
export class ListeBiensComponent implements OnInit {


  contactAcreer!: createContacts;
  showbouttonliberation: boolean = false;
  creeContactboolean: boolean = false;
  contactCreer!: createContacts;
  typeOption: any;
  contactOption!: string;
  vendeurOption!: string;
  userRole!: string[];
  userProfil: userProfilDto = {
    nom: '',
    prenom: '',
    role: [],
    enable: true,
    mail: ''

  }
  contactfound: any = true;
  statutlotCode: any;
  changeStatut() {
    throw new Error('Method not implemented.');
  }

  loading = true;
  civilites: Civil[] | undefined;
  Selectedcivilites: Civil[] | undefined;
  lotdetail: Lot[] = [];
  title: string = 'Grille de prix';
  cols!: any[];
  symbole: string = '€';
  unite: string = 'm2';
  programme!: Ope;
  urlPlan!: any;
  visible: boolean = false;
  prefix: string = 'Pieces';
  link: any;
  somme!: number;
  constReduit: any;
  constTTC: number = 0;
  Bienselected!: Bien;
  bienselectionee!: LotBynumOpe;
  balcon!: number;
  buttonprolongation: boolean = false;
  dto: renewOption = {
    "resi_idoption": "",
    "resi_source": "",
    "resi_statutlotcode": 0,
    "resi_reconduction": 1
  }
  surfJardin!: number;
  surfTerrasse!: number;
  tantieme!: number;
  statut!: string;
  nomCommercial!: string;
  numbien!: number;
  vignettedetails!: vignetteOpe
  urlImageVig!: string;
  matchModeOptions!: SelectItem[];
  statuses: Statuses[] = [{ label: 'Aucun', value: 'Aucun' }];
  selectedContact!: Value | null;
  selectedfromInput!: Value;
  selectedContactshare!: Value;
  contactSearch!: contactsDto;
  values!: Value[];
  simpleContactForm!: SimpleContactForm;
  afficheForm!: boolean;
  target!: HTMLElement;
  mobileDisplay!: boolean;
  criteriaSearch!: SearchOpeCriteria;
  first!: HTMLElement;
  NewListLot!: LotBynumOpe[];
  maliste: LotBynumOpe[] = [];
  detailSecondaire: lotSecondaireDto[] = [];
  container: boolean = false;
  error: any;
  disabled = false;
  contactDto!: ContactDto;
  selectedcivilite!: Civil;
  private _destroy$: Subject<void> = new Subject();
  datefinoptiondisplay!: number
  tyopo: Statuses[] = [{
    label: 'Aucun',
    value: 'Aucun'
  }];
  bol: boolean = false;
  optionFormIntern!: FormGroup;
  optionFormExtern!: FormGroup;
  emptyMsgBeforSearch = false;
  vendeurEmailOption!: string;
  usernameAuthenticated!: string;
  idVendeurWincom!: string;
  idVendeurWincomOption!: string;

  @HostListener('window:resize', ['$event.target.innerWidth'])

  onResize(width: number) {
    if (width <= 768) {
      this.mobileDisplay = true;
    } else {
      this.mobileDisplay = false;
    }
  }

  constructor(private formBuilder: FormBuilder, private fb: FormBuilder, private messageService: MessageService, public optionService: OptionServices, private _sidebar: SidebarService,
    public scrollService: ScrollService, private scroller: ViewportScroller, public share: shareOpeSevices, private biservice: BienService, public router: Router, public filter: FilterService, private contactsService: ContactsService,
    public docsndVigneteService: DocServices, private opeService: OpeService, private persist: PersistanceService, private kcService: KeycloakService, private collab: collabService) {
    this.urlPlan = '';

  }
  @Input()
  public listebien!: Bien[];
  entiteForm = this.fb.group({
    firstname: ['', Validators.required],
    lastname: ['', Validators.required],
    email: ['', Validators.required],
    telephone: ['', Validators.required]

  });
  ngOnInit() {
    this.usernameAuthenticated = this.kcService.getUsername();

    this.collab.getCollabByEmail(this.usernameAuthenticated).subscribe(data => {

      this.idVendeurWincom = data.numPrimpromo;

    });


    this.simpleContactForm = {
      contactid: '',
      resi_contactid: '',
      firstname: '',
      lastname: '',
      emailaddress: '',
      mobilephone: '',
      civilite: ''
    }

    this.share.datasOpe$.subscribe(data => {

      this.programme = data

    });
    this.share.searchcrit$.subscribe(critere => {
      this.criteriaSearch = critere
    });

    this.share.vignetteDetails$.subscribe(res => {

      this.vignettedetails = res;
      this.urlImageVig = this.vignettedetails.url;

    });


    this.cols = [{ field: 'nomCommercial', header: 'Lot', showFilter: 'false' },
    { field: "libelleStatut", header: "Statut", showFilter: 'true' },
    { field: "typeAbrg", header: "Type", showFilter: 'true' },
    { field: "etage", header: "Etage", showFilter: 'false' },
    { field: "surface", header: "Surface", showFilter: 'false' },
    { field: "prixPublication", header: "Prix TVA 20% Annexes incluses", showFilter: 'false' },
    { field: "prixPublication", header: "Prix TVA 5,5% Annexes incluses", showFilter: 'false' }];

    this.getLotsbynumOpe(this.programme.numOpe, this.criteriaSearch);
    this.optionFormIntern = this.formBuilder.group({
      civilite: [''],
      nom: [''],
      prenom: [''],
      email: [''],
      telephone: ['']
    });


    this.optionFormExtern = this.formBuilder.group({
      civilite: [''],
      nom: ['', Validators.required],
      prenom: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}')]],
      telephone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]]
    });


    // this.share.data$.subscribe(data => {

    //   this.listebien = data;
    //   this.loading = false;

    // });



    this.civilites = [
      { type: 'Mr', code: '370410000' },
      { type: 'Mme', code: '370410001' }

    ];



    //this.getLotsbynumOpe(this.programme.numOpe);

    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
    this.share.userProfilshared$.subscribe(data => {
      this.userProfil.nom = data.nom;
      this.userProfil.prenom = data.prenom;
      this.userProfil.mail = data.mail
      this.userRole = data.role;

    })

  }
  // 
  Ifeligiblefunction(bien: LotBynumOpe): any {
    if ((bien.tauxTva) === 20) {

      return "-";
    }
    else return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(Math.round(bien.prixTotHt * (1 + 5.5 / 100)))


  }
  get f() { return this.optionFormExtern.controls; }


  getBidocument(bien: LotBynumOpe) {
    this.share.showprogressbar = true;
    this.onScrollToAnchor();

    this.biservice.getPlanBiBynumOpe(bien.numBi).pipe(


      map((data: any) => {

        if (data.urlPlan != null) {
          // this.loader = true; 


          this._sidebar.addNewNotification(
            EnumTypeNotification.INFO,
            'Plan ' + data.nom + ' en cours de téléchargement ...',
            '',
            true,
            true

          );


          setTimeout(() => {
            this._sidebar.addNewNotification(
              EnumTypeNotification.SUCCESS,
              'Téléchargé avec succès !',
              '',
              true,
              true

            );
            window.open(data.urlPlan);
            this.share.showprogressbar = false;
          }, 1500);
        }

        else if (data.urlPlan == '' || data.urlPlan == undefined) {

          this._sidebar.addNewNotification(
            EnumTypeNotification.ERREUR,
            'Plan Vide!' + data.content.length,
            '',
            true,
            true
          );
          this.share.showprogressbar = false;

        };
      }),
      catchError(this.handleError), takeUntil(this._destroy$)
    ).

      subscribe(data => {
        //data.urlPlan
        //    window.open(data.urlPlan);

      });

  }

  annulerOption() {

    this.afficheForm = false;
    this.simpleContactForm = {
      contactid: '',
      resi_contactid: '',
      firstname: '',
      lastname: '',
      emailaddress: '',
      mobilephone: '',
      civilite: ''
    }
    this.init();
  }

  onScrollToAnchor() {
    // this.scroller.scrollToAnchor('main');
    const sasa = document.getElementById("tagProgbar")
    sasa?.scrollIntoView({ behavior: 'smooth' })
    // this.scroller.scrollToAnchor("montag")
  }
  handleError = (error: HttpErrorResponse) => {

    if (error.status === 404) {

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Plan non trouvé, code erreur: ' + error.status + ' ',
        '' + error.status + ' ',
        true,
        true
      );

      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;

      }
      return of(error.message);

    } if (error.status === 503) {
      //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Service indsponible - code erreur : ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      return of(error.message);
    }
    //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');

    if (error.status === 502) {
      //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Bad Gatway - POD ne repond pas - code erreur : ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      return of(error.message);
    }
    if (error.status === 504) {
      //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Timeout Gatway - code erreur ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      return of(error.message);
    }


    if (error.status === 500) {

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Mauvaise requette, veuillez bien selectionner les bons param - code erreur ' + error.status + ' .',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      return of(error.message);
    }
    else {

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Erreur Inconnu  - code erreur ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      return of(error.message);
    }
  };

  // Permet de charger la dto lotdetail avec les info du bien 
  // transformation des prix des annexes et prix du bien principale en fonction du type de TVA
  //
  showDialog(bien: LotBynumOpe, isValidOption: Boolean) {

    this.selectedContact = {
      firstname: ' Nom, prénom, mail.. ',
      lastname: '',
      emailaddress1: '',
      "@odata.etag": '',
      contactid: '',
      core_civility: '',
      mobilephone: '',
      resi_contactid: '',
      fullname: ''
    };

    this.selectedContact = null
    // code rajouté par MAS pour corriger object object dans le contact


    this.optionService.getOptionEnCoursLot(this.programme.numOpeExt, bien.numBiExt).subscribe({
      next: data => {


        if (data === null || data === undefined) {
          this.showbouttonliberation = false;
          this.statut = bien.libelleStatut;
          this.typeOption = '';
          this.contactOption = '';
          this.vendeurOption = '';
          this.datefinoptiondisplay = 0;
          if (isValidOption) this.messageService.add({ severity: 'warr', detail: "Votre option n'est pas prise en compte" });

        } else {
          this.idVendeurWincomOption = data.idvendeurwincom;
          this.datefinoptiondisplay = data.resiDatefinoption;
          this.mapstatusOptionCode(data.resiStatutlotcode);
          this.contactOption = (data.nom ?? '') + ' ' + (data.prenom ?? '');
          this.vendeurOption = data.vendeur;
          this.statut = 'Option';
          if (isValidOption) this.messageService.add({ severity: 'success', detail: 'Votre option est bien prise en compte' });
          this.statutlotCode = data.resiStatutlotcode ?? '';
          if (data.resiStatutlotcode === 852810001) {
            this.buttonprolongation = true;
          }
        }
      }, error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    });
    this.share.showprogressbar = true;
    this.bienselectionee = bien;
    this.biservice.getDetailsLotBynumBie(bien.numBi).subscribe((data: lotDetails) => {
      this.share.showprogressbar = false;

      this.detailSecondaire = data.lotSecondaireDtos;

      this.afficheForm = false;

      this.simpleContactForm = {
        contactid: '',
        resi_contactid: '',
        firstname: '',
        lastname: '',
        emailaddress: '',
        mobilephone: '',
        civilite: ''
      }

      this.lotdetail = [];
      this.nomCommercial = bien.nomCommercial;
      this.visible = true;
      this.numbien = bien.numBi;
      this.balcon = bien.surfBalcon;
      this.surfJardin = bien.surfJardin;
      this.surfTerrasse = bien.surfTerrasse;
      //this.tantieme = bien.;


      if (bien.tauxTva === 5.5) {

        this.lotdetail.push({
          name: bien.nomCommercial,
          id: bien.type,
          type: bien.typologie,
          etage: bien.etage,
          surface: bien.surface,
          prix20: Math.round(bien.prixCatHt * 1.2),
          prix5: Math.round(bien.prixCatHt * 1.055),
          prixTotalTTC: 0,
          prixTotalReduit: 0,

        });

        this.detailSecondaire.forEach((annexe: lotSecondaireDto) => {
          this.lotdetail.push({
            name: annexe.nomCommercial,
            id: annexe.type,
            type: annexe.typologie,
            etage: annexe.etage,
            surface: annexe.surface,
            prix20: Math.round(annexe.prixCatHt * 1.2),
            prix5: Math.round(annexe.prixCatHt * 1.055),
            prixTotalTTC: 0,
            prixTotalReduit: 0,

          })
        });

      }

      else if (bien.tauxTva === 20) {

        this.lotdetail.push({
          name: bien.nomCommercial,
          id: bien.type,
          type: bien.typologie,
          etage: bien.etage,
          surface: bien.surface,
          prix20: Math.round(bien.prixCatHt * 1.2),
          prix5: 0,
          prixTotalTTC: 0,
          prixTotalReduit: 0,

        })

        this.detailSecondaire.forEach((annexe: lotSecondaireDto) => {
          this.lotdetail.push({
            name: annexe.nomCommercial,
            id: annexe.type,
            type: annexe.typologie,
            etage: annexe.etage,
            surface: annexe.surface,
            prix20: Math.round(annexe.prixCatHt * 1.2),
            prix5: 0,
            prixTotalTTC: 0,
            prixTotalReduit: 0,

          })
        });
      }
      this.constTTC = 0;
      this.constReduit = 0;
      this.lotdetail.forEach(element => {

        this.constTTC = this.constTTC + element.prix20;
        if (bien.tauxTva === 5.5) {

          this.constReduit = this.constReduit + element.prix5;
        }
        else if (bien.tauxTva == 20) {
          this.constReduit = 0
        }
      })
    })
  }

  public arrondir(data: number) {

    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(Math.round(data));

  }

  public ChangeSeverity(stauts: string) {

    switch (stauts) {
      case "Réservé": return "danger"
      case "Libre": return "primary"
      case "Option": return "info"
      default: return "warn"
    }

  }

  sommationPrixTTC(bien: Bien): number {
    bien.annexeDto.forEach(element => this.somme += Math.round(element.prixCatalogue))
    return this.somme + Math.round(bien.prixCatHt);

  }

  getBidocumentbynum(numbien: number) {

    this.biservice.getPlanBiBynumOpe(numbien

    ).pipe(map((data: any) => {

      if (data.urlPlan != null) {
        // this.loader = true; 


        this._sidebar.addNewNotification(
          EnumTypeNotification.INFO,
          'Plan ' + data.nom + ' en cours de téléchargement ...',
          '',
          true,
          true

        );


        setTimeout(() => {
          this._sidebar.addNewNotification(
            EnumTypeNotification.SUCCESS,
            'Téléchargé avec succès !',
            '',
            true,
            true
          );
          window.open(data.urlPlan);
          this.share.showprogressbar = false;
        }, 1500);
      }

      else if (data.urlPlan == '' || data.urlPlan == undefined) {

        this._sidebar.addNewNotification(
          EnumTypeNotification.ERREUR,
          'Plan Vide!' + data.content.length,
          '',
          true,
          true
        );
        this.share.showprogressbar = false;

      };
    }),
      catchError(this.handleError), takeUntil(this._destroy$)
    ).subscribe(
      data => {
        // //data.urlPlan
        // window.open(data.urlPlan);
      });

  }

  filterforSeach(event: AutoCompleteCompleteEvent) {

    const nom = event.query;

    if (nom.length > 4)
      this.contactfound = this.contactsService.getContactsFromCRM(nom).pipe(map((data: contactsDto) => {

        this.contactSearch = data;
        if (this.contactSearch.value.length > 0 || this.contactSearch !== null || this.contactSearch !== undefined) {
          this.values = [...this.contactSearch.value];
          this.bol = false;
        }
        if (this.contactSearch.value.length === 0 || this.contactSearch === null || this.contactSearch == undefined) {
          this.bol = true;

        }
      }), catchError(this.handleError), takeUntil(this._destroy$)).subscribe()

        ;

  }


  sendContact(event: any) {

    this.afficheForm = true;
    this.disabled = true;
    this.optionFormIntern.value.nom = event.firstname;

    this.optionFormIntern.value.prenom = event.lastname;

    this.optionFormIntern.value.telephone = event.mobilephone;
    this.optionFormIntern.value.email = event.emailaddress1;

    this.simpleContactForm.contactid = event.contactid;
    this.simpleContactForm.firstname = event.firstname;
    this.simpleContactForm.lastname = event.lastname;
    this.simpleContactForm.emailaddress = event.emailaddress1;
    this.simpleContactForm.mobilephone = event.mobilephone;
    this.optionFormIntern.value.telephone = event.mobilephone;
  }



  getLotsbynumOpe(numOpe: number, filtre: SearchOpeCriteria) {

    this.biservice.getListBienbynumOpe(numOpe, filtre).subscribe((data: any) => {
      this.NewListLot = data.content;
      this.loading = false;
      this.statuses.length = 0;
      this.tyopo.length = 0;
      this.emptyMsgBeforSearch = true;

      this.NewListLot.forEach((data: LotBynumOpe) => {

        this.statuses.push({
          label: data.libelleStatut,
          value: data.libelleStatut
        });

        this.tyopo.push({
          label: data.typeAbrg,
          value: data.typeAbrg
        });

      });
      this.statuses = this.removeDuplicates(this.statuses, 'label');

      this.tyopo = this.removeDuplicates(this.tyopo, 'label');

    }

    )

  }

  scroll(el: HTMLElement) {
    this.first = el;
    this.first.scrollIntoView({ behavior: "smooth" });
  }

  ngOnDestroy() {

    this._destroy$.next();
    this._destroy$.complete();
  }
  removeDuplicates(myArray: any[], Prop: string) {

    return myArray.filter((obj: any, pos: number, arr: any[]) => {
      return arr.map((mapObj: any) => mapObj[Prop as keyof typeof mapObj]).indexOf(obj[Prop as keyof typeof obj]) === pos;
    });
  }
  init() {

    this.simpleContactForm = {
      contactid: '',
      civilite: '',
      emailaddress: '',
      lastname: '',
      firstname: '',
      resi_contactid: '',
      mobilephone: '',
    };
  }

  newFormContact(el: HTMLElement) {
    this.afficheForm = true;
    this.disabled = false;
    this.init();
    this.bol = false;
    this.creeContactboolean = true;
    this.scroll(this.first);
    this.first.scrollIntoView({ behavior: "smooth" });

  }


  option() {
    this.share.showprogressbar = true;
    //this.contactAcreer.core_civility=this.civilites.code;
    let dto: OptionCreateDto = new OptionCreateDto();
    // if(this.hasRole("externe")){
    //   this.share.showprogressbar = true;

    // this.simpleContactForm.lastname = this.optionFormExtern.value.prenom ?? '';
    // this.simpleContactForm.firstname = this.optionFormExtern.value.nom ?? '';
    // this.simpleContactForm.emailaddress = this.optionFormExtern.value.email ?? '';
    // this.simpleContactForm.mobilephone = this.optionFormExtern.value.telephone ?? '';
    //   // this.contactAcreer.emailaddress1 = this.simpleContactForm?.emailaddress;
    //   this.contactAcreer = {
    //     contactid: '',
    //     core_civility: "370410001",
    //     emailaddress1: this.simpleContactForm.emailaddress,
    //     lastname: this.simpleContactForm.lastname,
    //     firstname: this.simpleContactForm.firstname,
    //     mobilephone: this.simpleContactForm.mobilephone,
    //     core_PersonnalAddressLine1: '',
    //     core_PersonnalAddressLine2: '',
    //     core_PersonnalAddressLine3: '',
    //     core_PersonnalAddressZipCode: '',
    //     core_PersonnalAddressCity: '',
    //     core_personnaladdresscountryid: ''

    //   }

    //   this.contactsService.createContacts(this.contactAcreer).subscribe({

    //     next: ((data: any) => {


    //       dto.resi_commentaires = "Option 3 jours depuis Extranet";

    //       dto["resi_optionepourcontactid@odata.bind"] = data.contactid;
    //       dto.resi_commentaires = "Option 3 jours depuis Extranet";
    //       dto.resi_optionnepourcontactemail = this.simpleContactForm.emailaddress;
    //       dto.resi_optionnepourcontactprenom = this.simpleContactForm.firstname;
    //       dto.resi_optionnepourcontactnom = this.simpleContactForm.lastname;
    //       dto.resi_optionnepourcontacttelephone = this.simpleContactForm.mobilephone;

    //       dto.resi_datedebutoption = new Date();
    //       dto.resi_datefinoption = new Date();
    //       dto.resi_datefinoption.setDate(dto.resi_datedebutoption.getDate() + 3);
    //       dto.resi_dateliberationreelle = new Date();
    //       dto.resi_dateliberationreelle?.setDate(dto.resi_datedebutoption.getDate() + 3);
    //       dto.resi_reconduction = 0;

    //       dto['resi_lotid@odata.bind'] = this.programme.numOpeExt + this.bienselectionee.numBiExt;
    //       dto.resi_statutlotcode = 852810004;


    //       dto.resi_source = "Extranet";


    //       if (this.userProfil.mail !== undefined) {
    //         dto.resi_emailvendeur =  this.userProfil.mail;
    //       }
    //       if (this.userProfil.nom !== undefined) {
    //         dto.resi_nomvendeur =  this.userProfil.nom;
    //       }

    //       if (this.userProfil.prenom !== undefined) {
    //         dto.resi_prenomvendeur =  this.userProfil.prenom;
    //       }


    //       this.optionService.postOption(dto).subscribe({ 

    //         next: (CreateReponseType => {


    //         );
    //         if (CreateReponseType.CreateReponseType
    //           .returnMessage === 'ok') {

    //           this.share.showprogressbar = false; 
    //           this.afficheForm = false;
    //           this.messageService.add({ severity: 'success', detail: 'Votre option est bien prise en compte' });
    //           this.contactOption =  this.simpleContactForm.firstname+' '+this.simpleContactForm.lastname;
    //           this.vendeurOption=  dto.resi_nomvendeur+' '+ dto.resi_prenomvendeur;
    //           this.optionFormExtern.reset();
    //           this.optionFormIntern.reset();

    //           this.showDialog(this.bienselectionee);


    //         }
    //         else {
    //           this.share.showprogressbar = false; 
    //        }

    //       }),error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    //     })

    //   }), error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    // })
    // }



    if ((this.creeContactboolean || (this.selectedContact === undefined || this.selectedContact === null))) {

      // this.contactAcreer.emailaddress1 = this.simpleContactForm?.emailaddress;
      this.contactAcreer = {
        contactid: '',
        core_civility: "370410001",
        emailaddress1: this.optionFormIntern.value.email,
        lastname: this.optionFormIntern.value.nom,
        firstname: this.optionFormIntern.value.prenom,
        mobilephone: this.optionFormIntern.value.telephone,
        core_PersonnalAddressLine1: '',
        core_PersonnalAddressLine2: '',
        core_PersonnalAddressLine3: '',
        core_PersonnalAddressZipCode: '',
        core_PersonnalAddressCity: '',
        core_personnaladdresscountryid: ''

      }


      this.contactsService.createContacts(this.contactAcreer).subscribe({

        next: ((data: any) => {


          dto.resi_commentaires = "Option 3 jours depuis Extranet";

          dto["resi_optionepourcontactid@odata.bind"] = data.contactid;
          dto.resi_commentaires = "Option 3 jours depuis Extranet";
          dto.resi_optionnepourcontactemail = this.simpleContactForm.emailaddress;
          dto.resi_optionnepourcontactprenom = this.simpleContactForm.firstname;
          dto.resi_optionnepourcontactnom = this.simpleContactForm.lastname;
          dto.resi_optionnepourcontacttelephone = this.simpleContactForm.mobilephone;

          dto.resi_datedebutoption = new Date();
          let dateFin = new Date();
          dateFin.setDate(dto.resi_datedebutoption.getDate() + 3);
          dto.resi_datefinoption = dateFin;


          dto.resi_dateliberationreelle = new Date();
          dto.resi_dateliberationreelle = dateFin;

          dto.resi_reconduction = 0;

          dto['resi_lotid@odata.bind'] = this.programme.numOpeExt + this.bienselectionee.numBiExt;
          dto.resi_statutlotcode = 852810004;


          dto.resi_source = "Extranet";


          if (this.userProfil.mail !== undefined) {
            dto.resi_emailvendeur = this.userProfil.mail;
          }
          if (this.userProfil.nom !== undefined) {
            dto.resi_nomvendeur = this.userProfil.nom;
          }

          if (this.userProfil.prenom !== undefined) {
            dto.resi_prenomvendeur = this.userProfil.prenom;
          }


          this.optionService.postOption(dto).subscribe({

            next: (CreateReponseType => {


              if (CreateReponseType.CreateReponseType
                .returnMessage === 'ok') {

                this.share.showprogressbar = false;
                this.afficheForm = false; (data.nom ?? '') + ' ' + (data.prenom ?? '');
                this.contactOption = (this.simpleContactForm.firstname ?? '') + ' ' + (this.simpleContactForm.lastname ?? '');
                this.vendeurOption = dto.resi_nomvendeur + ' ' + dto.resi_prenomvendeur;
                this.optionFormExtern.reset();
                this.optionFormIntern.reset();


                this.showDialog(this.bienselectionee, false);


              }
              else {
                this.share.showprogressbar = false;
              }

            }), error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
          })

        }), error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
      })
    }

    else {

      //370410000: Monsieur  --> 02
      //370410001: Madame  --> 03
      //370410002: Mademoiselle --> 04

      // dto.resi_optionnepourcontactcivilite = this.selectedcivilite!.code;

      dto.resi_commentaires = "Option 3 jours depuis Extranet";
      dto.resi_optionnepourcontactemail = this.optionFormIntern.value.email;
      dto.resi_optionnepourcontactprenom = this.optionFormIntern.value.prenom;
      dto.resi_optionnepourcontactnom = this.optionFormIntern.value.nom;
      dto.resi_optionnepourcontacttelephone = this.optionFormIntern.value.telephone;
      dto["resi_optionepourcontactid@odata.bind"] = this.selectedContact.contactid;
      dto.resi_datedebutoption = new Date();
      let dateFin = new Date();
      dateFin.setDate(dto.resi_datedebutoption.getDate() + 3);
      dto.resi_datefinoption = dateFin;
      dto.resi_dateliberationreelle = dateFin;
      dto.resi_reconduction = 0;
      dto['resi_lotid@odata.bind'] = this.programme.numOpeExt + this.bienselectionee.numBiExt;
      dto.resi_statutlotcode = 852810004;

      this.datefinoptiondisplay = dto.resi_datefinoption.setDate(dateFin.getDate());

      dto.resi_source = "Extranet";

      /*
        console.log("resi_datedebutoption====///>", dto.resi_datedebutoption)
        console.log("resi_datefinoption====///>", dto.resi_datefinoption)
        console.log("resi_dateliberationreelle====///>", dto.resi_dateliberationreelle)
      */

      if (this.userProfil.mail !== undefined) {
        dto.resi_emailvendeur = this.userProfil.mail;
      }
      if (this.userProfil.nom !== undefined) {
        dto.resi_nomvendeur = this.userProfil.nom;
      }

      if (this.userProfil.prenom !== undefined) {
        dto.resi_prenomvendeur = this.userProfil.prenom;
      }



      this.optionService.postOption(dto).subscribe({

        next: (CreateReponseType => {


          if (CreateReponseType.CreateReponseType
            .returnMessage === 'ok') {
            this.share.showprogressbar = false;

            //this.messageService.add({ severity: 'success', detail: 'Votre option est bien prise en compte' });
            this.contactOption = `${this.optionFormIntern.value.nom ?? ''} ${this.optionFormIntern.value.prenom ?? ''}`;
            this.vendeurOption = `${dto.resi_nomvendeur} ${dto.resi_prenomvendeur}`;
            this.showDialog(this.bienselectionee, true);
          }
          else {
            this.share.showprogressbar = false;
            //this.messageService.add({ severity: 'warn', detail: "Votre option n'est pas prise en compte" });
          }

        }), error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })

      })
    }


  }
  libertation() {

    let dto: OptionFreeDto = new OptionFreeDto();

    dto['resi_lotid@odata.bind'] = this.programme.numOpeExt + this.bienselectionee.numBiExt;
    dto.resi_idoption = '1734932-1';
    this.optionService.annulerOption(dto).subscribe(response => {

    })
  }
  reconduction() {

    let dto: OptionReconductionDto = new OptionReconductionDto();
    dto.resi_datedebutOption = new Date();
    dto.resi_datefinOption = new Date();
    dto.resi_datefinOption.setDate(dto.resi_datedebutOption.getDate() + 15);
    dto.resi_dateliberationreelle = new Date();
    dto.resi_dateliberationreelle?.setDate(dto.resi_datedebutOption.getDate() + 15);
    dto['resi_lotid@odata.bind'] = this.programme.numOpeExt + this.Bienselected.numBiExt;

  }
  mapstatusOptionCode(char: number): string {
    this.typeOption = '';
    if (char === 852810001) {

      return this.typeOption = '15 jours';

    };
    if (char === 852810004) {

      return this.typeOption = '3 jours';

    }
    if (char === 852810000) {

      return this.typeOption = '5 jours';
    };

    if (char === 852810002) {

      return this.typeOption = 'Hors délais';
    };
    if (char === 852810003) {

      return this.typeOption = 'Blocage en dur';
    }
    else return '';
  }

  populateOption(programmeseled: Ope) {
    this.optionService.getOptionByProgramme(programmeseled.numOpeExt).subscribe((data) => {
      this.share.sendOptions(data);


    });
  }
  handleClose() {

    this.getLotsbynumOpe(this.programme.numOpe, this.criteriaSearch);
    this.share.sendOpeN(this.programme);

    this.populateOption(this.programme);



    //const progPres = new ProgrammePresentationComponent;
    //Object.values(this.selectedContact).splice;

  }
  prolongation(): void {

    this.share.showprogressbar = true;

    //this.contactAcreer.core_civility=this.civilites.code;

    // //370410000: Monsieur  --> 02
    // //370410001: Madame  --> 03
    // //370410002: Mademoiselle --> 04

    // // dto.resi_optionnepourcontactcivilite = this.selectedcivilite!.code;
    this.optionService.getOptionEnCoursLot(this.programme.numOpeExt, this.bienselectionee.numBiExt).subscribe({

      next: data => {




        if (data === null || data === undefined) {


        } else if (data !== null) {
          this.dto.resi_idoption = data.resiIdoption;
          this.dto.resi_reconduction = 1;
          this.dto.resi_statutlotcode = data.resiStatutlotcode;
          this.dto.resi_source = "Extranet";
          if (data.resiStatutlotcode === 852810001) {
            this.buttonprolongation = true;
            this.statutlotCode = 852810001
          }
          this.optionService.postProlongationOption(this.dto).subscribe({

            next: (CreateReponseType: any) => {



              if (CreateReponseType.CreateReponseType
                .returnMessage === 'ok') {

                this.messageService.add({ severity: 'success', detail: "Votre prolongation est bien prise en compte" });

                // this.optionService.getOptionEnCoursLot(this.programme.numOpeExt, this.bienselectionee.numBiExt).subscribe({

                //   next: data => {

                //     // this.contactOption = data.nom + ' '+data.prenom;
                //     // this.vendeurOption = data.vendeur;
                //     // this.datefinoptiondisplay = data.resiDateliberationreelle;
                //     this.
                //   },error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })})
                // this.share.showprogressbar = false;
                this.showDialog(this.bienselectionee, false);
                this.buttonprolongation = true;
                this.statutlotCode = 852810001;
                this.share.showprogressbar = false;

              }
              else {

                this.messageService.add({ severity: 'warn', detail: "Votre prolongation n'est pas prise en compte" });
                this.share.showprogressbar = false;

              }

            }, error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })

          })
        }

      }, error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    });




  }

  optionExtern() {

    this.share.showprogressbar = true;
    //this.contactAcreer.core_civility=this.civilites.code;
    let dto: OptionCreateDto = new OptionCreateDto();
    this.simpleContactForm.lastname = this.optionFormExtern.value.prenom ?? '';
    this.simpleContactForm.firstname = this.optionFormExtern.value.nom ?? '';
    this.simpleContactForm.emailaddress = this.optionFormExtern.value.email ?? '';
    this.simpleContactForm.mobilephone = this.optionFormExtern.value.telephone ?? '';
    // this.contactAcreer.emailaddress1 = this.simpleContactForm?.emailaddress;
    this.contactAcreer = {
      contactid: '',
      core_civility: "370410001",
      emailaddress1: this.simpleContactForm.emailaddress,
      lastname: this.simpleContactForm.lastname,
      firstname: this.simpleContactForm.firstname,
      mobilephone: this.simpleContactForm.mobilephone,
      core_PersonnalAddressLine1: '',
      core_PersonnalAddressLine2: '',
      core_PersonnalAddressLine3: '',
      core_PersonnalAddressZipCode: '',
      core_PersonnalAddressCity: '',
      core_personnaladdresscountryid: ''

    }


    this.contactsService.createContacts(this.contactAcreer).subscribe({

      next: ((data: any) => {



        dto.resi_commentaires = "Option 3 jours depuis Extranet";

        dto["resi_optionepourcontactid@odata.bind"] = data.contactid;
        dto.resi_commentaires = "Option 3 jours depuis Extranet";
        dto.resi_optionnepourcontactemail = this.simpleContactForm.emailaddress;
        dto.resi_optionnepourcontactprenom = this.simpleContactForm.firstname;
        dto.resi_optionnepourcontactnom = this.simpleContactForm.lastname;
        dto.resi_optionnepourcontacttelephone = this.simpleContactForm.mobilephone;

        dto.resi_datedebutoption = new Date();
        dto.resi_datefinoption = new Date();
        dto.resi_datefinoption.setDate(dto.resi_datedebutoption.getDate() + 3);
        dto.resi_dateliberationreelle = new Date();
        dto.resi_dateliberationreelle?.setDate(dto.resi_datedebutoption.getDate() + 3);
        dto.resi_reconduction = 0;

        dto['resi_lotid@odata.bind'] = this.programme.numOpeExt + this.bienselectionee.numBiExt;
        dto.resi_statutlotcode = 852810004;


        dto.resi_source = "Extranet";


        if (this.userProfil.mail !== undefined) {
          dto.resi_emailvendeur = this.userProfil.mail;
        }
        if (this.userProfil.nom !== undefined) {
          dto.resi_nomvendeur = this.userProfil.nom;
        }

        if (this.userProfil.prenom !== undefined) {
          dto.resi_prenomvendeur = this.userProfil.prenom;
        }



        this.optionService.postOption(dto).subscribe({

          next: (CreateReponseType => {


            if (CreateReponseType.CreateReponseType
              .returnMessage === 'ok') {

              this.share.showprogressbar = false;
              this.afficheForm = false;
              //this.messageService.add({ severity: 'success', detail: 'Votre option est bien prise en compte' });
              this.contactOption = (this.simpleContactForm.firstname ?? '') + ' ' + (this.simpleContactForm.lastname ?? '');
              this.vendeurOption = dto.resi_nomvendeur + ' ' + dto.resi_prenomvendeur;

              this.vendeurEmailOption = dto.resi_emailvendeur;
              this.optionFormExtern.reset();
              this.optionFormIntern.reset();

              this.showDialog(this.bienselectionee, true);


            }
            else {
              this.share.showprogressbar = false;
            }

          }), error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
        })

      }), error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    })


  }

  hasRole(role: string): boolean {

    if (this.userRole && this.userRole.length > 0) {


      return this.userRole.includes(role);

    }

    return false;
  }




}